





























import AnalyzeCustomServices, { AnalyzeCustomDto } from '@/services/analyzeCustom';
import moment from 'moment';
import { Vue, Component } from 'vue-property-decorator';
import BoardList from './board-group.vue';
@Component({
  components: { BoardList }
})
export default class Todo extends Vue {
  customSrv = new AnalyzeCustomServices();
  groupBy: string = 'boardGroup';
  spinning: boolean = false;

  created() {
    this.getList();
  }

  query: string = '';
  onSearch() {
    this.getList({ boardName_like: this.query });
  }

  boardList: AnalyzeCustomDto[] = [];
  async getList(params?: object) {
    this.spinning = true;
    this.boardList = await this.customSrv.getList(params);
    this.spinning = false;
  }

  get groupsList() {
    let list: any[] = [];
    let key: string = this.groupBy;
    if (key === 'modifyTime') {
      list = [{ groupName: '时间排序', list: this.enabledList }];
    } else {
      this.enabledList.forEach((v: any) => {
        let idx = list.findIndex(l => l.groupName === v[key]);
        if (idx > -1) {
          list[idx].list.push(v);
        } else {
          let groupName = (typeof v[key] === 'undefined' || v[key] === '') ? '未分组' : v[key];
          list.push({ groupName: groupName, list: [v] });
        }
      });
    }
    return list;
  }

  get enabledList() {
    return this.boardList.filter(v => v.status === 0).sort((a: any, b: any) => moment(b.modifyTime).valueOf() - moment(a.modifyTime).valueOf());
  }

  get disabledList() {
    return this.boardList.filter(v => v.status === 1);
  }

  transGroupName(name: number | string) {
    if (this.groupBy === 'boardTool') {
      let tools = ['漏斗分析', '占比分析', '趋势分析', '指标墙分析'];
      return tools[+name];
    } else {
      return name;
    }
  }

  add() {
    this.$router.push('/analyze/custom/add');
  }
}
